// A canceled request is not a failure: the caller navigated away or the
// client-side abort/timeout signal fired. Rejecting with a typed Error (instead
// of axios's bare "canceled" string) keeps a stack trace and lets error
// handlers filter cancellations by type.
export class RequestCanceledError extends Error {
  constructor() {
    super("Request canceled");
    this.name = "RequestCanceledError";
  }
}
